import { depthSchema } from "../schemas/index.js";
export class DepthResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /**
     * Full per-partner order-book ladders for one position. The position hash is
     * colon-separated (6 parts) and MUST be URL-encoded into the path segment —
     * bare colons otherwise break routing. Bulk depth is not yet available, so this
     * is strictly one hash per request.
     */
    getDepth(positionHash) {
        return this.http.request({
            method: "GET",
            path: `/depth/${encodeURIComponent(positionHash)}`,
            endpoint: "depth.getDepth",
            dataSchema: depthSchema,
        });
    }
}
//# sourceMappingURL=depth.js.map